import React from 'react';

import { Calendar } from '@carbon/icons-react';

import Icon from 'components/Icon/Icon';

import block from 'utils/bem-css-modules';
import { convertToDisplayDateString, isDateValid } from 'utils/helpers/dateHelpers';
import { formatMessage } from 'utils/messages/utils';

import style from './TerritoryPillEffectiveDates.module.pcss';

const b = block(style);

interface TerritoryPillEffectiveDatesProps {
  startDate: string | null;
  endDate: string | null;
  fill: string;
}

const TerritoryPillEffectiveDates: React.FC<TerritoryPillEffectiveDatesProps> = ({
  startDate,
  endDate,
  fill
}: TerritoryPillEffectiveDatesProps) => {
  if (!startDate && !endDate) return null;

  const startDateText = isDateValid(startDate) ? convertToDisplayDateString(startDate) : formatMessage('NO_START_DATE');
  const endDateText = isDateValid(endDate) ? convertToDisplayDateString(endDate) : formatMessage('NO_END_DATE');

  return (
    <div className={b()}>
      <Icon icon={<Calendar fill={fill} />} />
      <span className={b('date')} data-testid="effective-dates-text">
        {formatMessage('TERRITORY_PILL_DATE', { startDate: startDateText, endDate: endDateText })}
      </span>
    </div>
  );
};

export default TerritoryPillEffectiveDates;
